import type { LaunchableWindowKind } from '../data/protocol/types';
import { getWindowShortcutHint } from '../shortcuts/shortcuts';
import { Button } from '../ui/Button/Button';
import { Modal } from '../ui/Modal/Modal';
import { LAUNCHABLE_WINDOW_KINDS, WINDOW_DEFINITIONS } from './windowRegistry';

interface AddWindowModalProps {
  open: boolean;
  onClose: () => void;
  onAdd: (kind: LaunchableWindowKind) => void;
}

export function AddWindowModal({ open, onClose, onAdd }: AddWindowModalProps) {
  return (
    <Modal title="Add Window" open={open} onClose={onClose}>
      <div className="window-picker">
        {LAUNCHABLE_WINDOW_KINDS.map((kind) => {
          const definition = WINDOW_DEFINITIONS[kind];
          const shortcutHint = getWindowShortcutHint(kind);

          return (
            <button
              key={kind}
              className="window-picker__item"
              onClick={() => {
                onAdd(kind);
                onClose();
              }}
            >
              <span className="window-picker__icon">{definition.icon}</span>

              <span className="window-picker__copy">
                <strong>{definition.title}</strong>
                <small>
                  {definition.description}
                  {shortcutHint ? ` (${shortcutHint})` : ''}
                </small>
              </span>
            </button>
          );
        })}
      </div>

      <footer className="modal__footer">
        <Button variant="ghost" onClick={onClose}>
          Cancel
        </Button>
      </footer>
    </Modal>
  );
}